// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle4 from "../../randing/RandingStyle4";

function Randing011({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/010/20241112010.gif`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/010/20241113_01.jpg`}
      benefitInfoPosition="bottom"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/010/20241112010_1.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing011;
